import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseSkeleton',
  props: {
    height: { default: '50px' },
    width: { default: '100%' },
    marginTop: { default: '12px' },
    lines: { default: 1 }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (item) => {
    return (_openBlock(), _createElementBlock("div", {
      key: item,
      class: "BaseSkeleton placeholder-loading",
      style: _normalizeStyle({height: _ctx.height, width: _ctx.width, marginTop: _ctx.marginTop})
    }, null, 4))
  }), 128))
}
}

})